type NetworkConfig = {
  name: string
  knowledge: string
  publication: string
  multicall: string | undefined
  // [key: string]: string
}

export const networkConfig: { [key: number]: NetworkConfig } = {
  31337: {
    name: "localhost",
    publication: "0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512",
    knowledge: "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0",
    multicall: "0x5FbDB2315678afecb367f032d93F642f64180aa3"
  },
  80001: {
    name: "mumbai",
    publication: "0xD301BB8268d132b766a9C4Cbf7bb65255773B12a",
    knowledge: "0xa29926acf3e023C4B48fc6A0f5EA9E45bDd0affB",
    // multicall lib finds the multicall contract automatically
    multicall: undefined
  },
  137: {
    name: "polygon",
    publication: "0x507e1A26aAE6E8313664D08e697aBC246Eb56a14",
    knowledge: "0x2890F4D991CD72C9703c45e24042DA4cfF1b937c",
    multicall: undefined
  },
}
